import React from 'react';

export const administratorPagesConfig = [
  {
    auth: ['calenderManagement', 'holidaysManagement'],
    routes: [
      {
        path: '/calendar-management/holidays',
        component: React.lazy(() => import('./Pages/HolidaysPage')),
      },
    ],
  },
  {
    auth: ['calenderManagement', 'closuresManagement'],
    routes: [
      {
        path: '/calendar-management/closures',
        component: React.lazy(() => import('./Pages/ClosuresPage')),
      },
    ],
  },
  {
    auth: ['calenderManagement', 'hoursOfOperationManagement'],
    routes: [
      {
        path: '/calendar-management/hours',
        component: React.lazy(() => import('./Pages/HoursPage')),
      },
    ],
  },
  {
    auth: ['configSetManagement'],
    routes: [
      {
        path: '/contact-flows',
        component: React.lazy(() => import('./Pages/ConfigurationSetPage')),
      },
    ],
  },
  {
    auth: ['syncManagement'],
    routes: [
      {
        path: '/sync/path-mappings',
        component: React.lazy(() => import('./Pages/MappingSyncPage')),
      },
    ],
  },
  {
    auth: ['syncManagement'],
    routes: [
      {
        path: '/sync/contact-flows',
        component: React.lazy(() => import('./Pages/ContactFlowSyncPage')),
      },
    ],
  },
  {
    auth: ['syncManagement'],
    routes: [
      {
        path: '/sync/config-sets',
        component: React.lazy(() => import('./Pages/ConfigSetSyncPage')),
      },
    ],
  },
  {
    auth: ['syncManagement'],
    routes: [
      {
        path: '/sync/lambdas',
        component: React.lazy(() => import('./Pages/LambdaSyncPage')),
      },
    ],
  },
  {
    auth: ['admin'],
    routes: [
      {
        path: '/admin',
        component: React.lazy(() => import('./Pages/Landing')),
      },
    ],
  },
  {
    auth: ['menuManagement'],
    routes: [
      {
        path: '/menu-management',
        component: React.lazy(() => import('./Pages/MenuManagementPage')),
      },
    ],
  },
  {
    auth: ['entryManagement'],
    routes: [
      {
        path: '/contact-entry-points',
        component: React.lazy(
          () => import('./Pages/ContactEntryPointManagementPage'),
        ),
      },
    ],
  },
  {
    auth: ['queueTreatmentManagement'],
    routes: [
      {
        path: '/queue-treatment',
        component: React.lazy(() => import('./Pages/QueueTreatmentPage')),
      },
    ],
  },
  {
    auth: ['admin'],
    routes: [
      {
        path: '/tenant-management',
        component: React.lazy(() => import('./Pages/TenantManagementPage')),
      },
    ],
  },
  {
    auth: ['admin', 'userManagement'],
    routes: [
      {
        path: '/user-management/permissions',
        component: React.lazy(
          () => import('./Pages/PermissionsManagementPage'),
        ),
      },
    ],
  },
  {
    auth: ['connectUserManagement'],
    routes: [
      {
        path: '/connect/user-management',
        component: React.lazy(
          () => import('./Pages/Connect/UserManagementPage'),
        ),
      },
    ],
  },
  {
    auth: [
      'metrics',
      'realTimeMetricsQueues',
      'realTimeMetricsRoutingProfiles',
      'realTimeMetricsAgents',
      'realTimeMetricsSnapshot'
    ],
    routes: [
      {
        path: '/connect/metrics/realtime-metrics',
        component: React.lazy(
          () => import('./Pages/Connect/RealtimeMetricsPage'),
        ),
      },
    ],
  },
  {
    auth: ['metrics', 'historicalMetrics'],
    routes: [
      {
        path: '/connect/metrics/historical-metrics',
        component: React.lazy(
          () => import('./Pages/Connect/HistoricalMetricsPage'),
        ),
      },
    ],
  },
  {
    auth: ['metrics', 'contactSearch'],
    routes: [
      {
        path: '/connect/contact-search',
        component: React.lazy(
          () => import('./Pages/Connect/ContactSearchPage'),
        ),
      },
    ],
  },
];
